import { injectable } from 'tsyringe';
import type {
    AssistInput,
    Classification,
    ClassificationDraft,
    ClassificationOutputType,
    ClassificationStatus,
    CreateClassificationInput,
    UpdateClassificationInput,
} from '@bmai/context-api-client';
import { contextClient } from '@/shared/ContextApiClient';

export type {
    AssistInput,
    Classification,
    ClassificationDraft,
    ClassificationOutputType,
    ClassificationStatus,
    CreateClassificationInput,
    UpdateClassificationInput,
};

/** Wraps the generated classifications API for the builder ViewModel. */
@injectable()
export class ClassificationService {
    list(): Promise<Classification[]> {
        return contextClient.classificationsApi.getClassifications();
    }

    async create(input: CreateClassificationInput): Promise<void> {
        await contextClient.classificationsApi.postClassifications({ createClassificationInput: input });
    }

    update(id: string, input: UpdateClassificationInput): Promise<Classification> {
        return contextClient.classificationsApi.putById({ id, updateClassificationInput: input });
    }

    delete(id: string): Promise<void> {
        return contextClient.classificationsApi.deleteById({ id });
    }

    assist(input: AssistInput): Promise<ClassificationDraft> {
        return contextClient.classificationsApi.postAssist({ assistInput: input });
    }
}
